import { render, staticRenderFns } from "./orderTable.vue?vue&type=template&id=bf9ddc1e&scoped=true"
import script from "./orderTable.vue?vue&type=script&lang=js"
export * from "./orderTable.vue?vue&type=script&lang=js"
import style0 from "./orderTable.vue?vue&type=style&index=0&id=bf9ddc1e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9ddc1e",
  null
  
)

export default component.exports